import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MeetingResponseModel } from '../../models/meetingModel/MeetingResponseModel'
import { MeetingNameResponseModel } from '../../models/meetingModel/MeetingNameResponseModel';
import { MeetingDefaultResponseModel } from '../../models/meetingModel/MeetingDefaultResponseModel';

@Injectable({
  providedIn: 'root'
})
export class MeetingService {

  private base = environment.urlServerApi+'meetings';

  constructor(private _http: HttpClient) {
  }

  getMeetingByFilter(data:any): Observable<MeetingResponseModel>{
    console.log('SERVICE: getMeetingByFilter')
    return this._http.post<MeetingResponseModel>(`${this.base}`, data)
  }

  getMeetingName(): Observable<MeetingNameResponseModel>{
    console.log('SERVICE: getMeetingName')
    return this._http.get<MeetingNameResponseModel>(`${this.base}`)
  }

  getLatesMeetings(): Observable<MeetingResponseModel>{
    console.log('SERVICE: getLatesMeetings')
    return this._http.get<MeetingResponseModel>(`${this.base}/last`)
  }

  getMeetingById(meetingId: number): Observable<MeetingDefaultResponseModel>{
    console.log('SERVICE: getMeetingById')
    return this._http.get<MeetingDefaultResponseModel>(`${this.base}/meeting/?meetingId=${meetingId}`)
  }

}
